import { ReactElement } from 'react';
import { createKey } from '@client/common/utils/key/key';
import { Alert, ALERT_STYLE_TYPE } from 'b2b-components/theme/components/Alert';
import { Props } from './';
import './DangerDetails.scss';

export const DangerDetails = ({ dangerDetails }: Props): ReactElement => (
  <div className='ProductDescription-DangerDetails'>
    <Alert styleType={ALERT_STYLE_TYPE.warning}>
      <ul className='cds-List--Unstyled'>
        {dangerDetails.map((group) => (
          <li key={group.id}>
            <strong className='ProductDescription-DangerDetailsGroup'>
              {group.name}:
            </strong>
            <ul className='ProductDescription-DangerDetailsList cds-List cds-List--Bulleted'>
              {group.values.map((danger, dangerKey) => (
                <li key={createKey(group.id, dangerKey)}>{danger}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </Alert>
  </div>
);
